import { basicMsg, htmlMsg } from '../swal_msg';
import { axiosProtectedReq } from '../../helpers/requestHelper';

// obtener imágenes de banners
export const bannerList = async(setBanner) => {
    const request = await axiosProtectedReq('banner/list');
    if (request.status) {
        const { desktop, tablet, mobile } = request.resp;
        setBanner(e => ({
            ...e, ...request.resp,
            backup: {
                ...e.backup,
                desktop: desktop.images,
                tablet: tablet.images,
                mobile: mobile.images
            }
        }));
    } else {
        if (request.msg !== 'no-results') {
            let txt = 'Ocurrió una incidencia';
            if (request.msg === 'server-err')
                txt = 'Error en servidor';
            else if (request.msg === 'request-err')
                txt = 'Error en petición';
            alert(txt);
        }
    }
};

// subir imágenes para banner
export const uploadBannerImages = async(
    { _id, type }, setBanner, backupImages,
    newImages, deletedImages, setDeletedImages
) => {
    const data = new FormData();
    data.append('_id', _id);
    data.append('type', type);
    data.append('imagesData', JSON.stringify(newImages));
    data.append('cloudImages', JSON.stringify(backupImages));
    data.append('deletedImages', JSON.stringify(deletedImages));
    
    for (const item of newImages) {
        data.append('file', item.img);
    };
    const request = await axiosProtectedReq('banner/upload-images', data, 'POST');
    if (request.status) {
        const { _id: banner_id, images, new_collection, messages } = request.resp;
        if (new_collection) // se incluye ID
            setBanner(e => ({
                ...e,
                [type]: {
                    ...e[type], _id: banner_id, images
                },
                backup: {
                    ...e.backup,
                    [type]: images
                },
                images: []
            }));
        else
            setBanner(e => ({
                ...e,
                [type]: {
                    ...e[type], images
                },
                backup: {
                    ...e.backup,
                    [type]: images
                },
                images: []
            }));
        setDeletedImages(e => ({
            ...e, [type]: []
        }));
        
        if (messages.length > 0)
            htmlMsg(
                'warning', 'Banners actualizados',
                `<div style="text-align: left; padding-left: 0pt;"><ul>${messages.join('')}</ul></div>`
            );
        else
            basicMsg('Cambios guardados');
    } else {
        const { msg } = request;
        let txt = 'Ocurrió una incidencia';
        if (msg === 'banner-not-saved')
            txt = 'No se pudo guardar la información';
        else if (msg === 'server-err')
            txt = 'Error en servidor';
        else if (msg === 'request-err')
            txt = 'Error en petición';
        basicMsg(txt);
    }
};